/** @format */

import { useReducer, createContext, useContext } from 'react';
import { initialState, reducer } from './reducer';

export const ShowroomContext = createContext();

export const useShowroom = () => useContext(ShowroomContext);

export const ShowroomProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <ShowroomContext.Provider value={[state, dispatch]}>
      {children}
    </ShowroomContext.Provider>
  );
};
